import { Box } from '@mui/material';
import { SystemRequirement } from '@/components/SystemRequirement';
import { DefaultLayout } from '@/layouts';
import { useFetchCookies } from '@/hooks';
import { PageLoader } from '@/components/shared/PageLoader';

export const SystemTest = () => {
  const cookiesFetched = useFetchCookies();

  if (!cookiesFetched) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }

  return (
    <DefaultLayout>
      <SystemRequirement />
    </DefaultLayout>
  );
};
